// extracted by mini-css-extract-plugin
export default {"Drawer":"HxIpLC2SczHMqrByhsVU","kycBannerContainer":"nzgoI_V0IslTmLpDRroe","kycLeftContent":"gS5Zexc8T951TUSaObre","kycIcon":"xGGa5oU8xGA3KfRcdIzE","kycText":"q9mVPNxMVf3BqmI6srRn","kycCta":"cW_gnTrIqNBpdFtCARjh","closeIcon":"H99GbuFk2G1eMIY1yxZM"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"Drawer\":\"HxIpLC2SczHMqrByhsVU\",\"kycBannerContainer\":\"nzgoI_V0IslTmLpDRroe\",\"kycLeftContent\":\"gS5Zexc8T951TUSaObre\",\"kycIcon\":\"xGGa5oU8xGA3KfRcdIzE\",\"kycText\":\"q9mVPNxMVf3BqmI6srRn\",\"kycCta\":\"cW_gnTrIqNBpdFtCARjh\",\"closeIcon\":\"H99GbuFk2G1eMIY1yxZM\"}";
        // 1790170452740
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  